(function () {
  // Datos reales del producto "Magnesium Complex" (bamboolabs.com).
  // Si algún día cambias el precio del producto, actualiza aquí el campo
  // "price" a mano (va en céntimos: 27,95€ => 2795) para que el -20% se
  // calcule bien.
  var MAGNESIO = {
    variantId: 48656195518810,
    title: 'Magnesium Complex',
    image: 'https://cdn.shopify.com/s/files/1/0556/3315/0298/files/TOPO2-01.jpg?v=1762773116',
    price: 2795,
    discountCode: 'MAGNESIO20', // el código que crees en Admin > Descuentos
    discountPercent: 20
  };

  var BANNER_ID = 'mu-magnesio-upsell';

  function muFindDrawerContainer() {
    // Lista de selectores habituales donde insertar el banner, de más a menos
    // específico. AJUSTA el primero si no encaja con el tema: abre el carrito,
    // inspecciona el HTML con las herramientas de desarrollador y busca el
    // contenedor justo ANTES del botón "Finalizar compra" / "Realizar pedido".
    var selectors = [
      '#CartDrawer .drawer__footer',
      '#CartDrawer-footer',
      '.cart-drawer__footer',
      '#CartDrawer .cart__footer',
      '#CartDrawer'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function muFormatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  function muBuildBanner() {
    var discounted = Math.round(MAGNESIO.price * (100 - MAGNESIO.discountPercent) / 100);

    var wrapper = document.createElement('div');
    wrapper.id = BANNER_ID;
    wrapper.className = 'mu-banner';
    wrapper.innerHTML =
      '<div class="mu-banner__image">' +
        '<img src="' + MAGNESIO.image + '" alt="' + MAGNESIO.title + '" loading="lazy">' +
      '</div>' +
      '<div class="mu-banner__body">' +
        '<div class="mu-banner__eyebrow">Completa tu pedido</div>' +
        '<div class="mu-banner__title">' + MAGNESIO.title + '</div>' +
        '<div class="mu-banner__price">' +
          '<span class="mu-banner__price--new">' + muFormatPrice(discounted) + '</span>' +
          '<span class="mu-banner__price--old">' + muFormatPrice(MAGNESIO.price) + '</span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="mu-banner__btn" data-mu-add>' +
        '<span data-mu-btn-label>Añadir -' + MAGNESIO.discountPercent + '%</span>' +
      '</button>';
    return wrapper;
  }

  function muRemoveBanner() {
    var existing = document.getElementById(BANNER_ID);
    if (existing) existing.remove();
  }

  function muCheckCartAndRender() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = document.getElementById(BANNER_ID);
        var hasMagnesio = cart.items.some(function (i) {
          return i.variant_id === MAGNESIO.variantId;
        });

        // Se ofrece solo cuando el carrito tiene exactamente 1 unidad en total
        // y esa unidad no es ya el propio Magnesio.
        if (cart.item_count === 1 && !hasMagnesio) {
          if (!existing) {
            var container = muFindDrawerContainer();
            if (container) container.insertBefore(muBuildBanner(), container.firstChild);
          }
        } else if (existing) {
          existing.remove();
        }
      });
  }

  function muAddMagnesio() {
    var btn = document.querySelector('[data-mu-add]');
    var label = btn ? btn.querySelector('[data-mu-btn-label]') : null;
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Añadiendo...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: MAGNESIO.variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('No se pudo añadir el producto');
        return r.json();
      })
      .then(function () {
        // Aplica el código de descuento al carrito ya creado, vía AJAX.
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: MAGNESIO.discountCode })
        });
      })
      .then(function () {
        // Recarga para que el descuento se refleje con total seguridad en el
        // resumen del carrito y en checkout. Es la vía más fiable: si
        // compruebas que tu tema actualiza visualmente el carrito sin recargar
        // tras /cart/update.js, puedes cambiar esta línea por el refresco
        // propio del tema en vez de recargar la página entera.
        location.reload();
      })
      .catch(function () {
        if (label) label.textContent = 'Error, reintenta';
        if (btn) btn.disabled = false;
      });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mu-add]')) muAddMagnesio();
  });

  // Vuelve a comprobar cada vez que el carrito cambia, si el tema dispara
  // alguno de estos eventos propios.
  ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, muCheckCartAndRender);
  });

  // Red de seguridad: intercepta cualquier llamada a los endpoints del
  // carrito, por si el tema no dispara ninguno de los eventos anteriores.
  var muOriginalFetch = window.fetch;
  window.fetch = function () {
    var result = muOriginalFetch.apply(this, arguments);
    var url = arguments[0];
    if (typeof url === 'string' && /\/cart\/(add|change|update)\.js/.test(url)) {
      result.then(function () { setTimeout(muCheckCartAndRender, 300); });
    }
    return result;
  };

  // Primera comprobación al cargar la página, por si el carrito ya está
  // abierto o se abre justo después con 1 producto dentro.
  document.addEventListener('DOMContentLoaded', muCheckCartAndRender);
})();